/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Created.ai API
 * OpenAPI spec version: 1
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  Asset,
  AssetMove,
  AssetPage,
  AssetReindex,
  AssetReindexAll,
  AssetSearchPage,
  AssetZip,
  AssetZipRequest,
  DeleteFolderParams,
  ErrorEnvelope,
  ImportFromUrlHeaders,
  ListAssetsParams,
  MediaAccess,
  PrepareUploadHeaders,
  RecentFolder,
  SaveJobOutputHeaders,
  SaveRequest,
  SearchAssetsParams,
  StartZipHeaders,
  TeamStorage,
  TrashEmptied,
  TrashSummary,
  UploadRequest,
  UploadTicket,
  UrlImportRequest
} from '../../model';

import { apiRequest } from '../../../client';
import type { ErrorType } from '../../../client';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export const getListAssetsUrl = (teamId: string,
    brandId: string,
    params?: ListAssetsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    const explodeParameters = ["source","created_by"];

    if (Array.isArray(value) && explodeParameters.includes(key)) {
      value.forEach((v) => {
        normalizedParams.append(key, v === null ? 'null' : String(v));
      });
      return;
    }

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/teams/${teamId}/brands/${brandId}/assets?${stringifiedParams}` : `/api/v1/teams/${teamId}/brands/${brandId}/assets`
}

/**
 * The brand's ready assets, newest first or oldest first; `trash=true` lists the trash
 * instead. Each filter narrows the page: the kind, the folder (with `recursive=true` the
 * folders under it too, live's "Show nested"; 422 without `folder_id`), part of the name
 * (`search`),
 * where it came from (`source`, repeatable: any of them; `upload` is live's "Manual
 * Uploads"), the job type it was
 * generated by (`generation_type`, as `audio.sfx`), who added it (`created_by`, repeatable:
 * any of them) and a product its generation shows (`product_id`).
 * @summary List Assets
 */
export const listAssets = async (teamId: string,
    brandId: string,
    params?: ListAssetsParams, options?: Parameters<typeof apiRequest>[1]): Promise<AssetPage> => {

  return apiRequest<AssetPage>(getListAssetsUrl(teamId,brandId,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListAssetsQueryKey = (teamId: string,
    brandId: string,
    params?: ListAssetsParams,) => {
    return [
    `/api/v1/teams/${teamId}/brands/${brandId}/assets`, ...(params ? [params] : [])
    ] as const;
    }


export const getListAssetsQueryOptions = <TData = Awaited<ReturnType<typeof listAssets>>, TError = ErrorType<ErrorEnvelope>>(teamId: string,
    brandId: string,
    params?: ListAssetsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAssets>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListAssetsQueryKey(teamId,brandId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listAssets>>> = ({ signal }) => listAssets(teamId,brandId,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: teamId !== null && teamId !== undefined && brandId !== null && brandId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listAssets>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListAssetsQueryResult = NonNullable<Awaited<ReturnType<typeof listAssets>>>
export type ListAssetsQueryError = ErrorType<ErrorEnvelope>


export function useListAssets<TData = Awaited<ReturnType<typeof listAssets>>, TError = ErrorType<ErrorEnvelope>>(
 teamId: string,
    brandId: string,
    params: undefined |  ListAssetsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAssets>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listAssets>>,
          TError,
          Awaited<ReturnType<typeof listAssets>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListAssets<TData = Awaited<ReturnType<typeof listAssets>>, TError = ErrorType<ErrorEnvelope>>(
 teamId: string,
    brandId: string,
    params?: ListAssetsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAssets>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listAssets>>,
          TError,
          Awaited<ReturnType<typeof listAssets>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListAssets<TData = Awaited<ReturnType<typeof listAssets>>, TError = ErrorType<ErrorEnvelope>>(
 teamId: string,
    brandId: string,
    params?: ListAssetsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAssets>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List Assets
 */

export function useListAssets<TData = Awaited<ReturnType<typeof listAssets>>, TError = ErrorType<ErrorEnvelope>>(
 teamId: string,
    brandId: string,
    params?: ListAssetsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAssets>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListAssetsQueryOptions(teamId,brandId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getSaveJobOutputUrl = (teamId: string,
    brandId: string,) => {




  return `/api/v1/teams/${teamId}/brands/${brandId}/assets/from-generation`
}

/**
 * Keep a delivered job output in the library: a pending asset that the worker copies into
 * place. A second save of the same output returns the same asset.
 * @summary Save Job Output
 */
export const saveJobOutput = async (teamId: string,
    brandId: string,
    saveRequest: SaveRequest,
    headers: SaveJobOutputHeaders, options?: Parameters<typeof apiRequest>[1]): Promise<Asset> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiRequest<Asset>(getSaveJobOutputUrl(teamId,brandId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json',...headers, ...getHeaders(options?.headers) },
    body: JSON.stringify(saveRequest)
  }
);}





export const getSaveJobOutputMutationKey = () => ['saveJobOutput'] as const;

export const getSaveJobOutputMutationOptions = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof saveJobOutput>>, TError,SaveJobOutputMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof saveJobOutput>>, TError,SaveJobOutputMutationVariables, TContext> => {

const mutationKey = getSaveJobOutputMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof saveJobOutput>>, SaveJobOutputMutationVariables> = (props) => {
          const {teamId,brandId,data,headers} = props ?? {};

          return  saveJobOutput(teamId,brandId,data,headers,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SaveJobOutputMutationResult = NonNullable<Awaited<ReturnType<typeof saveJobOutput>>>
    export type SaveJobOutputMutationBody = SaveRequest
    export type SaveJobOutputMutationError = ErrorType<ErrorEnvelope>
    export type SaveJobOutputMutationVariables = {teamId: string;brandId: string;data: SaveRequest;headers: SaveJobOutputHeaders}

    /**
 * @summary Save Job Output
 */
export const useSaveJobOutput = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof saveJobOutput>>, TError,SaveJobOutputMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof saveJobOutput>>,
        TError,
        SaveJobOutputMutationVariables,
        TContext
      > => {
      return useMutation(getSaveJobOutputMutationOptions(options), queryClient);
    }
    export const getImportFromUrlUrl = (teamId: string,
    brandId: string,) => {




  return `/api/v1/teams/${teamId}/brands/${brandId}/assets/from-url`
}

/**
 * Keep a picture on the web in the library (#249): a pending asset that the worker fetches
 * into place if it is still the file declared, else fails. A replayed key returns the same
 * asset.
 * @summary Import From Url
 */
export const importFromUrl = async (teamId: string,
    brandId: string,
    urlImportRequest: UrlImportRequest,
    headers: ImportFromUrlHeaders, options?: Parameters<typeof apiRequest>[1]): Promise<Asset> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiRequest<Asset>(getImportFromUrlUrl(teamId,brandId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json',...headers, ...getHeaders(options?.headers) },
    body: JSON.stringify(urlImportRequest)
  }
);}





export const getImportFromUrlMutationKey = () => ['importFromUrl'] as const;

export const getImportFromUrlMutationOptions = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof importFromUrl>>, TError,ImportFromUrlMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof importFromUrl>>, TError,ImportFromUrlMutationVariables, TContext> => {

const mutationKey = getImportFromUrlMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof importFromUrl>>, ImportFromUrlMutationVariables> = (props) => {
          const {teamId,brandId,data,headers} = props ?? {};

          return  importFromUrl(teamId,brandId,data,headers,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ImportFromUrlMutationResult = NonNullable<Awaited<ReturnType<typeof importFromUrl>>>
    export type ImportFromUrlMutationBody = UrlImportRequest
    export type ImportFromUrlMutationError = ErrorType<ErrorEnvelope>
    export type ImportFromUrlMutationVariables = {teamId: string;brandId: string;data: UrlImportRequest;headers: ImportFromUrlHeaders}

    /**
 * @summary Import From Url
 */
export const useImportFromUrl = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof importFromUrl>>, TError,ImportFromUrlMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof importFromUrl>>,
        TError,
        ImportFromUrlMutationVariables,
        TContext
      > => {
      return useMutation(getImportFromUrlMutationOptions(options), queryClient);
    }
    export const getMoveAssetsUrl = (teamId: string,
    brandId: string,) => {




  return `/api/v1/teams/${teamId}/brands/${brandId}/assets/move`
}

/**
 * Live's Move to project (#668, spec S1c), from a card's menu or the bulk bar: every named
 * file into the folder, or to the brand's top level with `folder_id` null, all or nothing.
 * A file the library does not list, or a folder of another brand, is 422 at its field. Any
 * member, as on live.
 * @summary Move Assets
 */
export const moveAssets = async (teamId: string,
    brandId: string,
    assetMove: AssetMove, options?: Parameters<typeof apiRequest>[1]): Promise<void> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiRequest<void>(getMoveAssetsUrl(teamId,brandId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(assetMove)
  }
);}





export const getMoveAssetsMutationKey = () => ['moveAssets'] as const;

export const getMoveAssetsMutationOptions = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof moveAssets>>, TError,MoveAssetsMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof moveAssets>>, TError,MoveAssetsMutationVariables, TContext> => {

const mutationKey = getMoveAssetsMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof moveAssets>>, MoveAssetsMutationVariables> = (props) => {
          const {teamId,brandId,data} = props ?? {};

          return  moveAssets(teamId,brandId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type MoveAssetsMutationResult = NonNullable<Awaited<ReturnType<typeof moveAssets>>>
    export type MoveAssetsMutationBody = AssetMove
    export type MoveAssetsMutationError = ErrorType<ErrorEnvelope>
    export type MoveAssetsMutationVariables = {teamId: string;brandId: string;data: AssetMove}

    /**
 * @summary Move Assets
 */
export const useMoveAssets = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof moveAssets>>, TError,MoveAssetsMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof moveAssets>>,
        TError,
        MoveAssetsMutationVariables,
        TContext
      > => {
      return useMutation(getMoveAssetsMutationOptions(options), queryClient);
    }
    export const getReindexAllAssetsUrl = (teamId: string,
    brandId: string,) => {




  return `/api/v1/teams/${teamId}/brands/${brandId}/assets/reindex`
}

/**
 * Re-index all (spec S3, "At scale"): every ready image and video the brand's library lists
 * is indexed again, fairly with other teams' requests; one already pending is not asked again.
 * Any member, as the file's Re-index.
 * @summary Reindex All Assets
 */
export const reindexAllAssets = async (teamId: string,
    brandId: string, options?: Parameters<typeof apiRequest>[1]): Promise<AssetReindexAll> => {

  return apiRequest<AssetReindexAll>(getReindexAllAssetsUrl(teamId,brandId),
  {
    ...options,
    method: 'POST'


  }
);}





export const getReindexAllAssetsMutationKey = () => ['reindexAllAssets'] as const;

export const getReindexAllAssetsMutationOptions = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof reindexAllAssets>>, TError,ReindexAllAssetsMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof reindexAllAssets>>, TError,ReindexAllAssetsMutationVariables, TContext> => {

const mutationKey = getReindexAllAssetsMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof reindexAllAssets>>, ReindexAllAssetsMutationVariables> = (props) => {
          const {teamId,brandId} = props ?? {};

          return  reindexAllAssets(teamId,brandId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ReindexAllAssetsMutationResult = NonNullable<Awaited<ReturnType<typeof reindexAllAssets>>>

    export type ReindexAllAssetsMutationError = ErrorType<ErrorEnvelope>
    export type ReindexAllAssetsMutationVariables = {teamId: string;brandId: string}

    /**
 * @summary Reindex All Assets
 */
export const useReindexAllAssets = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof reindexAllAssets>>, TError,ReindexAllAssetsMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof reindexAllAssets>>,
        TError,
        ReindexAllAssetsMutationVariables,
        TContext
      > => {
      return useMutation(getReindexAllAssetsMutationOptions(options), queryClient);
    }
    export const getSearchAssetsUrl = (teamId: string,
    brandId: string,
    params: SearchAssetsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    const explodeParameters = ["source"];

    if (Array.isArray(value) && explodeParameters.includes(key)) {
      value.forEach((v) => {
        normalizedParams.append(key, v === null ? 'null' : String(v));
      });
      return;
    }

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/teams/${teamId}/brands/${brandId}/assets/search?${stringifiedParams}` : `/api/v1/teams/${teamId}/brands/${brandId}/assets/search`
}

/**
 * Live's semantic search of the library (spec S3): the brand's assets nearest in meaning
 * to `q`, best first, at most 256 points in all, a video once per matching scene. The list's
 * filters narrow it first: the kind, one folder (never its subfolders), where it came from
 * (`source`, repeatable), the job type it was generated by and a product its generation
 * shows. 404 while `CREATEDAI_FLAGS__SEMANTIC_SEARCH` is off; 503 `SEARCH_UNAVAILABLE` when
 * the search model does not answer; 60 searches a minute per member.
 * @summary Search Assets
 */
export const searchAssets = async (teamId: string,
    brandId: string,
    params: SearchAssetsParams, options?: Parameters<typeof apiRequest>[1]): Promise<AssetSearchPage> => {

  return apiRequest<AssetSearchPage>(getSearchAssetsUrl(teamId,brandId,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getSearchAssetsQueryKey = (teamId: string,
    brandId: string,
    params?: SearchAssetsParams,) => {
    return [
    `/api/v1/teams/${teamId}/brands/${brandId}/assets/search`, ...(params ? [params] : [])
    ] as const;
    }


export const getSearchAssetsQueryOptions = <TData = Awaited<ReturnType<typeof searchAssets>>, TError = ErrorType<ErrorEnvelope>>(teamId: string,
    brandId: string,
    params: SearchAssetsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof searchAssets>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSearchAssetsQueryKey(teamId,brandId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof searchAssets>>> = ({ signal }) => searchAssets(teamId,brandId,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: teamId !== null && teamId !== undefined && brandId !== null && brandId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof searchAssets>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type SearchAssetsQueryResult = NonNullable<Awaited<ReturnType<typeof searchAssets>>>
export type SearchAssetsQueryError = ErrorType<ErrorEnvelope>


export function useSearchAssets<TData = Awaited<ReturnType<typeof searchAssets>>, TError = ErrorType<ErrorEnvelope>>(
 teamId: string,
    brandId: string,
    params: SearchAssetsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof searchAssets>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof searchAssets>>,
          TError,
          Awaited<ReturnType<typeof searchAssets>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSearchAssets<TData = Awaited<ReturnType<typeof searchAssets>>, TError = ErrorType<ErrorEnvelope>>(
 teamId: string,
    brandId: string,
    params: SearchAssetsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof searchAssets>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof searchAssets>>,
          TError,
          Awaited<ReturnType<typeof searchAssets>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSearchAssets<TData = Awaited<ReturnType<typeof searchAssets>>, TError = ErrorType<ErrorEnvelope>>(
 teamId: string,
    brandId: string,
    params: SearchAssetsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof searchAssets>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Search Assets
 */

export function useSearchAssets<TData = Awaited<ReturnType<typeof searchAssets>>, TError = ErrorType<ErrorEnvelope>>(
 teamId: string,
    brandId: string,
    params: SearchAssetsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof searchAssets>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getSearchAssetsQueryOptions(teamId,brandId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetTrashUrl = (teamId: string,
    brandId: string,) => {




  return `/api/v1/teams/${teamId}/brands/${brandId}/assets/trash`
}

/**
 * What the brand's trash holds: its files, their bytes (which count toward the team's
 * storage until purged) and the days a file stays there. Any member.
 * @summary Get Trash
 */
export const getTrash = async (teamId: string,
    brandId: string, options?: Parameters<typeof apiRequest>[1]): Promise<TrashSummary> => {

  return apiRequest<TrashSummary>(getGetTrashUrl(teamId,brandId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetTrashQueryKey = (teamId: string,
    brandId: string,) => {
    return [
    `/api/v1/teams/${teamId}/brands/${brandId}/assets/trash`
    ] as const;
    }


export const getGetTrashQueryOptions = <TData = Awaited<ReturnType<typeof getTrash>>, TError = ErrorType<ErrorEnvelope>>(teamId: string,
    brandId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTrash>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetTrashQueryKey(teamId,brandId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getTrash>>> = ({ signal }) => getTrash(teamId,brandId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: teamId !== null && teamId !== undefined && brandId !== null && brandId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getTrash>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetTrashQueryResult = NonNullable<Awaited<ReturnType<typeof getTrash>>>
export type GetTrashQueryError = ErrorType<ErrorEnvelope>


export function useGetTrash<TData = Awaited<ReturnType<typeof getTrash>>, TError = ErrorType<ErrorEnvelope>>(
 teamId: string,
    brandId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTrash>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTrash>>,
          TError,
          Awaited<ReturnType<typeof getTrash>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTrash<TData = Awaited<ReturnType<typeof getTrash>>, TError = ErrorType<ErrorEnvelope>>(
 teamId: string,
    brandId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTrash>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTrash>>,
          TError,
          Awaited<ReturnType<typeof getTrash>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTrash<TData = Awaited<ReturnType<typeof getTrash>>, TError = ErrorType<ErrorEnvelope>>(
 teamId: string,
    brandId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTrash>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Trash
 */

export function useGetTrash<TData = Awaited<ReturnType<typeof getTrash>>, TError = ErrorType<ErrorEnvelope>>(
 teamId: string,
    brandId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTrash>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetTrashQueryOptions(teamId,brandId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getEmptyTrashUrl = (teamId: string,
    brandId: string,) => {




  return `/api/v1/teams/${teamId}/brands/${brandId}/assets/trash/empty`
}

/**
 * Empty trash: every file of the brand's trash purged, for good, its bytes freed from the
 * team's storage at once and the files gone for every reader; the sweep's next run (within 15
 * minutes) deletes their objects. It deletes others' files too, so an admin or the owner (403
 * for anyone else). A second call purges none.
 * @summary Empty Trash
 */
export const emptyTrash = async (teamId: string,
    brandId: string, options?: Parameters<typeof apiRequest>[1]): Promise<TrashEmptied> => {

  return apiRequest<TrashEmptied>(getEmptyTrashUrl(teamId,brandId),
  {
    ...options,
    method: 'POST'


  }
);}





export const getEmptyTrashMutationKey = () => ['emptyTrash'] as const;

export const getEmptyTrashMutationOptions = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof emptyTrash>>, TError,EmptyTrashMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof emptyTrash>>, TError,EmptyTrashMutationVariables, TContext> => {

const mutationKey = getEmptyTrashMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof emptyTrash>>, EmptyTrashMutationVariables> = (props) => {
          const {teamId,brandId} = props ?? {};

          return  emptyTrash(teamId,brandId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type EmptyTrashMutationResult = NonNullable<Awaited<ReturnType<typeof emptyTrash>>>

    export type EmptyTrashMutationError = ErrorType<ErrorEnvelope>
    export type EmptyTrashMutationVariables = {teamId: string;brandId: string}

    /**
 * @summary Empty Trash
 */
export const useEmptyTrash = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof emptyTrash>>, TError,EmptyTrashMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof emptyTrash>>,
        TError,
        EmptyTrashMutationVariables,
        TContext
      > => {
      return useMutation(getEmptyTrashMutationOptions(options), queryClient);
    }
    export const getStartZipUrl = (teamId: string,
    brandId: string,) => {




  return `/api/v1/teams/${teamId}/brands/${brandId}/assets/zip`
}

/**
 * Live's bulk Download as one `downloads.zip` (spec zip-download): 2 to 1,000 files the
 * library lists, 10 GiB at most in all (422 at the field otherwise), zipped by the worker.
 * Free, capped per team and hour; poll its `GET` for the URL.
 * @summary Start Zip
 */
export const startZip = async (teamId: string,
    brandId: string,
    assetZipRequest: AssetZipRequest,
    headers: StartZipHeaders, options?: Parameters<typeof apiRequest>[1]): Promise<AssetZip> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiRequest<AssetZip>(getStartZipUrl(teamId,brandId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json',...headers, ...getHeaders(options?.headers) },
    body: JSON.stringify(assetZipRequest)
  }
);}





export const getStartZipMutationKey = () => ['startZip'] as const;

export const getStartZipMutationOptions = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof startZip>>, TError,StartZipMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof startZip>>, TError,StartZipMutationVariables, TContext> => {

const mutationKey = getStartZipMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof startZip>>, StartZipMutationVariables> = (props) => {
          const {teamId,brandId,data,headers} = props ?? {};

          return  startZip(teamId,brandId,data,headers,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type StartZipMutationResult = NonNullable<Awaited<ReturnType<typeof startZip>>>
    export type StartZipMutationBody = AssetZipRequest
    export type StartZipMutationError = ErrorType<ErrorEnvelope>
    export type StartZipMutationVariables = {teamId: string;brandId: string;data: AssetZipRequest;headers: StartZipHeaders}

    /**
 * @summary Start Zip
 */
export const useStartZip = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof startZip>>, TError,StartZipMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof startZip>>,
        TError,
        StartZipMutationVariables,
        TContext
      > => {
      return useMutation(getStartZipMutationOptions(options), queryClient);
    }
    export const getGetZipUrl = (teamId: string,
    brandId: string,
    jobId: string,) => {




  return `/api/v1/teams/${teamId}/brands/${brandId}/assets/zip/${jobId}`
}

/**
 * A ZIP's job: its status, what it holds, and its signed URL once made; 404 for any other
 * job.
 * @summary Get Zip
 */
export const getZip = async (teamId: string,
    brandId: string,
    jobId: string, options?: Parameters<typeof apiRequest>[1]): Promise<AssetZip> => {

  return apiRequest<AssetZip>(getGetZipUrl(teamId,brandId,jobId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetZipQueryKey = (teamId: string,
    brandId: string,
    jobId: string,) => {
    return [
    `/api/v1/teams/${teamId}/brands/${brandId}/assets/zip/${jobId}`
    ] as const;
    }


export const getGetZipQueryOptions = <TData = Awaited<ReturnType<typeof getZip>>, TError = ErrorType<ErrorEnvelope>>(teamId: string,
    brandId: string,
    jobId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getZip>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetZipQueryKey(teamId,brandId,jobId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getZip>>> = ({ signal }) => getZip(teamId,brandId,jobId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: teamId !== null && teamId !== undefined && brandId !== null && brandId !== undefined && jobId !== null && jobId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getZip>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetZipQueryResult = NonNullable<Awaited<ReturnType<typeof getZip>>>
export type GetZipQueryError = ErrorType<ErrorEnvelope>


export function useGetZip<TData = Awaited<ReturnType<typeof getZip>>, TError = ErrorType<ErrorEnvelope>>(
 teamId: string,
    brandId: string,
    jobId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getZip>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getZip>>,
          TError,
          Awaited<ReturnType<typeof getZip>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetZip<TData = Awaited<ReturnType<typeof getZip>>, TError = ErrorType<ErrorEnvelope>>(
 teamId: string,
    brandId: string,
    jobId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getZip>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getZip>>,
          TError,
          Awaited<ReturnType<typeof getZip>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetZip<TData = Awaited<ReturnType<typeof getZip>>, TError = ErrorType<ErrorEnvelope>>(
 teamId: string,
    brandId: string,
    jobId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getZip>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Zip
 */

export function useGetZip<TData = Awaited<ReturnType<typeof getZip>>, TError = ErrorType<ErrorEnvelope>>(
 teamId: string,
    brandId: string,
    jobId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getZip>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetZipQueryOptions(teamId,brandId,jobId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getDeleteAssetUrl = (teamId: string,
    brandId: string,
    assetId: string,) => {




  return `/api/v1/teams/${teamId}/brands/${brandId}/assets/${assetId}`
}

/**
 * Into the trash for `TRASH_DAYS` (7). The creator, an admin or the owner.
 * @summary Delete Asset
 */
export const deleteAsset = async (teamId: string,
    brandId: string,
    assetId: string, options?: Parameters<typeof apiRequest>[1]): Promise<void> => {

  return apiRequest<void>(getDeleteAssetUrl(teamId,brandId,assetId),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getDeleteAssetMutationKey = () => ['deleteAsset'] as const;

export const getDeleteAssetMutationOptions = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteAsset>>, TError,DeleteAssetMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteAsset>>, TError,DeleteAssetMutationVariables, TContext> => {

const mutationKey = getDeleteAssetMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteAsset>>, DeleteAssetMutationVariables> = (props) => {
          const {teamId,brandId,assetId} = props ?? {};

          return  deleteAsset(teamId,brandId,assetId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteAssetMutationResult = NonNullable<Awaited<ReturnType<typeof deleteAsset>>>

    export type DeleteAssetMutationError = ErrorType<ErrorEnvelope>
    export type DeleteAssetMutationVariables = {teamId: string;brandId: string;assetId: string}

    /**
 * @summary Delete Asset
 */
export const useDeleteAsset = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteAsset>>, TError,DeleteAssetMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteAsset>>,
        TError,
        DeleteAssetMutationVariables,
        TContext
      > => {
      return useMutation(getDeleteAssetMutationOptions(options), queryClient);
    }
    export const getGetAssetUrl = (teamId: string,
    brandId: string,
    assetId: string,) => {




  return `/api/v1/teams/${teamId}/brands/${brandId}/assets/${assetId}`
}

/**
 * One asset of the brand, in any status, in the trash or not.
 * @summary Get Asset
 */
export const getAsset = async (teamId: string,
    brandId: string,
    assetId: string, options?: Parameters<typeof apiRequest>[1]): Promise<Asset> => {

  return apiRequest<Asset>(getGetAssetUrl(teamId,brandId,assetId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetAssetQueryKey = (teamId: string,
    brandId: string,
    assetId: string,) => {
    return [
    `/api/v1/teams/${teamId}/brands/${brandId}/assets/${assetId}`
    ] as const;
    }


export const getGetAssetQueryOptions = <TData = Awaited<ReturnType<typeof getAsset>>, TError = ErrorType<ErrorEnvelope>>(teamId: string,
    brandId: string,
    assetId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAsset>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAssetQueryKey(teamId,brandId,assetId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAsset>>> = ({ signal }) => getAsset(teamId,brandId,assetId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: teamId !== null && teamId !== undefined && brandId !== null && brandId !== undefined && assetId !== null && assetId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAsset>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAssetQueryResult = NonNullable<Awaited<ReturnType<typeof getAsset>>>
export type GetAssetQueryError = ErrorType<ErrorEnvelope>


export function useGetAsset<TData = Awaited<ReturnType<typeof getAsset>>, TError = ErrorType<ErrorEnvelope>>(
 teamId: string,
    brandId: string,
    assetId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAsset>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAsset>>,
          TError,
          Awaited<ReturnType<typeof getAsset>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAsset<TData = Awaited<ReturnType<typeof getAsset>>, TError = ErrorType<ErrorEnvelope>>(
 teamId: string,
    brandId: string,
    assetId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAsset>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAsset>>,
          TError,
          Awaited<ReturnType<typeof getAsset>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAsset<TData = Awaited<ReturnType<typeof getAsset>>, TError = ErrorType<ErrorEnvelope>>(
 teamId: string,
    brandId: string,
    assetId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAsset>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Asset
 */

export function useGetAsset<TData = Awaited<ReturnType<typeof getAsset>>, TError = ErrorType<ErrorEnvelope>>(
 teamId: string,
    brandId: string,
    assetId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAsset>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAssetQueryOptions(teamId,brandId,assetId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getReindexAssetUrl = (teamId: string,
    brandId: string,
    assetId: string,) => {




  return `/api/v1/teams/${teamId}/brands/${brandId}/assets/${assetId}/reindex`
}

/**
 * Live's Re-index (spec S3): the image or video is indexed for search again by the worker,
 * `pending` until it is; `skipped` for a kind the index leaves out. Any member.
 * @summary Reindex Asset
 */
export const reindexAsset = async (teamId: string,
    brandId: string,
    assetId: string, options?: Parameters<typeof apiRequest>[1]): Promise<AssetReindex> => {

  return apiRequest<AssetReindex>(getReindexAssetUrl(teamId,brandId,assetId),
  {
    ...options,
    method: 'POST'


  }
);}





export const getReindexAssetMutationKey = () => ['reindexAsset'] as const;

export const getReindexAssetMutationOptions = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof reindexAsset>>, TError,ReindexAssetMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof reindexAsset>>, TError,ReindexAssetMutationVariables, TContext> => {

const mutationKey = getReindexAssetMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof reindexAsset>>, ReindexAssetMutationVariables> = (props) => {
          const {teamId,brandId,assetId} = props ?? {};

          return  reindexAsset(teamId,brandId,assetId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ReindexAssetMutationResult = NonNullable<Awaited<ReturnType<typeof reindexAsset>>>

    export type ReindexAssetMutationError = ErrorType<ErrorEnvelope>
    export type ReindexAssetMutationVariables = {teamId: string;brandId: string;assetId: string}

    /**
 * @summary Reindex Asset
 */
export const useReindexAsset = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof reindexAsset>>, TError,ReindexAssetMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof reindexAsset>>,
        TError,
        ReindexAssetMutationVariables,
        TContext
      > => {
      return useMutation(getReindexAssetMutationOptions(options), queryClient);
    }
    export const getRestoreAssetUrl = (teamId: string,
    brandId: string,
    assetId: string,) => {




  return `/api/v1/teams/${teamId}/brands/${brandId}/assets/${assetId}/restore`
}

/**
 * Out of the trash, within its `TRASH_DAYS` (7). The creator, an admin or the owner.
 * @summary Restore Asset
 */
export const restoreAsset = async (teamId: string,
    brandId: string,
    assetId: string, options?: Parameters<typeof apiRequest>[1]): Promise<Asset> => {

  return apiRequest<Asset>(getRestoreAssetUrl(teamId,brandId,assetId),
  {
    ...options,
    method: 'POST'


  }
);}





export const getRestoreAssetMutationKey = () => ['restoreAsset'] as const;

export const getRestoreAssetMutationOptions = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof restoreAsset>>, TError,RestoreAssetMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof restoreAsset>>, TError,RestoreAssetMutationVariables, TContext> => {

const mutationKey = getRestoreAssetMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof restoreAsset>>, RestoreAssetMutationVariables> = (props) => {
          const {teamId,brandId,assetId} = props ?? {};

          return  restoreAsset(teamId,brandId,assetId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RestoreAssetMutationResult = NonNullable<Awaited<ReturnType<typeof restoreAsset>>>

    export type RestoreAssetMutationError = ErrorType<ErrorEnvelope>
    export type RestoreAssetMutationVariables = {teamId: string;brandId: string;assetId: string}

    /**
 * @summary Restore Asset
 */
export const useRestoreAsset = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof restoreAsset>>, TError,RestoreAssetMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof restoreAsset>>,
        TError,
        RestoreAssetMutationVariables,
        TContext
      > => {
      return useMutation(getRestoreAssetMutationOptions(options), queryClient);
    }
    export const getDeleteFolderUrl = (teamId: string,
    brandId: string,
    folderId: string,
    params?: DeleteFolderParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/teams/${teamId}/brands/${brandId}/folders/${folderId}?${stringifiedParams}` : `/api/v1/teams/${teamId}/brands/${brandId}/folders/${folderId}`
}

/**
 * Delete a folder (its creator or an admin), as live's two choices (A3b). `keep`, the
 * default: its assets are filed in `target` and its child folders move there (the brand's
 * top level when no `target`; 422 for a target under the folder or not the brand's, 409 when
 * a child is named as one of the target's). `delete`: every asset under it goes to the trash
 * and every folder under it goes (403 unless the actor may delete each, 409 `ASSET_IN_USE`
 * for a brand logo or a product image).
 * @summary Delete Folder
 */
export const deleteFolder = async (teamId: string,
    brandId: string,
    folderId: string,
    params?: DeleteFolderParams, options?: Parameters<typeof apiRequest>[1]): Promise<void> => {

  return apiRequest<void>(getDeleteFolderUrl(teamId,brandId,folderId,params),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getDeleteFolderMutationKey = () => ['deleteFolder'] as const;

export const getDeleteFolderMutationOptions = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteFolder>>, TError,DeleteFolderMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteFolder>>, TError,DeleteFolderMutationVariables, TContext> => {

const mutationKey = getDeleteFolderMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteFolder>>, DeleteFolderMutationVariables> = (props) => {
          const {teamId,brandId,folderId,params} = props ?? {};

          return  deleteFolder(teamId,brandId,folderId,params,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteFolderMutationResult = NonNullable<Awaited<ReturnType<typeof deleteFolder>>>

    export type DeleteFolderMutationError = ErrorType<ErrorEnvelope>
    export type DeleteFolderMutationVariables = {teamId: string;brandId: string;folderId: string;params?: DeleteFolderParams}

    /**
 * @summary Delete Folder
 */
export const useDeleteFolder = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteFolder>>, TError,DeleteFolderMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteFolder>>,
        TError,
        DeleteFolderMutationVariables,
        TContext
      > => {
      return useMutation(getDeleteFolderMutationOptions(options), queryClient);
    }
    export const getListRecentFoldersUrl = (teamId: string,
    brandId: string,) => {




  return `/api/v1/teams/${teamId}/brands/${brandId}/recent-folders`
}

/**
 * Home's Recent Projects (live's `GET /brand-projects/recent`): the brand's folders the
 * caller used last, newest first, at most five, each with how many assets it holds itself. A
 * folder counts as used when the caller makes it, opens it in the library (`GET .../assets`
 * with its `folder_id`), or saves, moves or uploads files into it.
 * @summary List Recent Folders
 */
export const listRecentFolders = async (teamId: string,
    brandId: string, options?: Parameters<typeof apiRequest>[1]): Promise<RecentFolder[]> => {

  return apiRequest<RecentFolder[]>(getListRecentFoldersUrl(teamId,brandId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListRecentFoldersQueryKey = (teamId: string,
    brandId: string,) => {
    return [
    `/api/v1/teams/${teamId}/brands/${brandId}/recent-folders`
    ] as const;
    }


export const getListRecentFoldersQueryOptions = <TData = Awaited<ReturnType<typeof listRecentFolders>>, TError = ErrorType<ErrorEnvelope>>(teamId: string,
    brandId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listRecentFolders>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListRecentFoldersQueryKey(teamId,brandId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listRecentFolders>>> = ({ signal }) => listRecentFolders(teamId,brandId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: teamId !== null && teamId !== undefined && brandId !== null && brandId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listRecentFolders>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListRecentFoldersQueryResult = NonNullable<Awaited<ReturnType<typeof listRecentFolders>>>
export type ListRecentFoldersQueryError = ErrorType<ErrorEnvelope>


export function useListRecentFolders<TData = Awaited<ReturnType<typeof listRecentFolders>>, TError = ErrorType<ErrorEnvelope>>(
 teamId: string,
    brandId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listRecentFolders>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listRecentFolders>>,
          TError,
          Awaited<ReturnType<typeof listRecentFolders>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListRecentFolders<TData = Awaited<ReturnType<typeof listRecentFolders>>, TError = ErrorType<ErrorEnvelope>>(
 teamId: string,
    brandId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listRecentFolders>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listRecentFolders>>,
          TError,
          Awaited<ReturnType<typeof listRecentFolders>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListRecentFolders<TData = Awaited<ReturnType<typeof listRecentFolders>>, TError = ErrorType<ErrorEnvelope>>(
 teamId: string,
    brandId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listRecentFolders>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List Recent Folders
 */

export function useListRecentFolders<TData = Awaited<ReturnType<typeof listRecentFolders>>, TError = ErrorType<ErrorEnvelope>>(
 teamId: string,
    brandId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listRecentFolders>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListRecentFoldersQueryOptions(teamId,brandId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getPrepareUploadUrl = (teamId: string,
    brandId: string,) => {




  return `/api/v1/teams/${teamId}/brands/${brandId}/uploads`
}

/**
 * Announce a file: a pending asset and the form to post it to the bucket with. With
 * `folder_id` the file lands in that folder of the brand (live's project; 422 at it for any
 * other), and its complete counts the folder as the caller's use.
 * @summary Prepare Upload
 */
export const prepareUpload = async (teamId: string,
    brandId: string,
    uploadRequest: UploadRequest,
    headers: PrepareUploadHeaders, options?: Parameters<typeof apiRequest>[1]): Promise<UploadTicket> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiRequest<UploadTicket>(getPrepareUploadUrl(teamId,brandId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json',...headers, ...getHeaders(options?.headers) },
    body: JSON.stringify(uploadRequest)
  }
);}





export const getPrepareUploadMutationKey = () => ['prepareUpload'] as const;

export const getPrepareUploadMutationOptions = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof prepareUpload>>, TError,PrepareUploadMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof prepareUpload>>, TError,PrepareUploadMutationVariables, TContext> => {

const mutationKey = getPrepareUploadMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof prepareUpload>>, PrepareUploadMutationVariables> = (props) => {
          const {teamId,brandId,data,headers} = props ?? {};

          return  prepareUpload(teamId,brandId,data,headers,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PrepareUploadMutationResult = NonNullable<Awaited<ReturnType<typeof prepareUpload>>>
    export type PrepareUploadMutationBody = UploadRequest
    export type PrepareUploadMutationError = ErrorType<ErrorEnvelope>
    export type PrepareUploadMutationVariables = {teamId: string;brandId: string;data: UploadRequest;headers: PrepareUploadHeaders}

    /**
 * @summary Prepare Upload
 */
export const usePrepareUpload = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof prepareUpload>>, TError,PrepareUploadMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof prepareUpload>>,
        TError,
        PrepareUploadMutationVariables,
        TContext
      > => {
      return useMutation(getPrepareUploadMutationOptions(options), queryClient);
    }
    export const getCompleteUploadUrl = (teamId: string,
    brandId: string,
    assetId: string,) => {




  return `/api/v1/teams/${teamId}/brands/${brandId}/uploads/${assetId}/complete`
}

/**
 * After the post: the asset becomes ready, or the mismatch is refused.
 * @summary Complete Upload
 */
export const completeUpload = async (teamId: string,
    brandId: string,
    assetId: string, options?: Parameters<typeof apiRequest>[1]): Promise<Asset> => {

  return apiRequest<Asset>(getCompleteUploadUrl(teamId,brandId,assetId),
  {
    ...options,
    method: 'POST'


  }
);}





export const getCompleteUploadMutationKey = () => ['completeUpload'] as const;

export const getCompleteUploadMutationOptions = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof completeUpload>>, TError,CompleteUploadMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof completeUpload>>, TError,CompleteUploadMutationVariables, TContext> => {

const mutationKey = getCompleteUploadMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof completeUpload>>, CompleteUploadMutationVariables> = (props) => {
          const {teamId,brandId,assetId} = props ?? {};

          return  completeUpload(teamId,brandId,assetId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CompleteUploadMutationResult = NonNullable<Awaited<ReturnType<typeof completeUpload>>>

    export type CompleteUploadMutationError = ErrorType<ErrorEnvelope>
    export type CompleteUploadMutationVariables = {teamId: string;brandId: string;assetId: string}

    /**
 * @summary Complete Upload
 */
export const useCompleteUpload = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof completeUpload>>, TError,CompleteUploadMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof completeUpload>>,
        TError,
        CompleteUploadMutationVariables,
        TContext
      > => {
      return useMutation(getCompleteUploadMutationOptions(options), queryClient);
    }
    export const getClearMediaAccessUrl = (teamId: string,) => {




  return `/api/v1/teams/${teamId}/media-access`
}

/**
 * Clear the team's media cookies in this browser. Browser sessions only.
 * @summary Clear Media Access
 */
export const clearMediaAccess = async (teamId: string, options?: Parameters<typeof apiRequest>[1]): Promise<void> => {

  return apiRequest<void>(getClearMediaAccessUrl(teamId),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getClearMediaAccessMutationKey = () => ['clearMediaAccess'] as const;

export const getClearMediaAccessMutationOptions = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof clearMediaAccess>>, TError,ClearMediaAccessMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof clearMediaAccess>>, TError,ClearMediaAccessMutationVariables, TContext> => {

const mutationKey = getClearMediaAccessMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof clearMediaAccess>>, ClearMediaAccessMutationVariables> = (props) => {
          const {teamId} = props ?? {};

          return  clearMediaAccess(teamId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ClearMediaAccessMutationResult = NonNullable<Awaited<ReturnType<typeof clearMediaAccess>>>

    export type ClearMediaAccessMutationError = ErrorType<ErrorEnvelope>
    export type ClearMediaAccessMutationVariables = {teamId: string}

    /**
 * @summary Clear Media Access
 */
export const useClearMediaAccess = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof clearMediaAccess>>, TError,ClearMediaAccessMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof clearMediaAccess>>,
        TError,
        ClearMediaAccessMutationVariables,
        TContext
      > => {
      return useMutation(getClearMediaAccessMutationOptions(options), queryClient);
    }
    export const getGrantMediaAccessUrl = (teamId: string,) => {




  return `/api/v1/teams/${teamId}/media-access`
}

/**
 * Set the team's media cookies (spec assets/media-cookies), so this browser reads the
 * team's files and the shared ones at their own URLs until `expires_at`, at most 1 h 15 min.
 * Each call checks the membership again and signs anew. Browser sessions only (403
 * `FORBIDDEN` otherwise); with cookies off, `enabled: false` and no cookie.
 * @summary Grant Media Access
 */
export const grantMediaAccess = async (teamId: string, options?: Parameters<typeof apiRequest>[1]): Promise<MediaAccess> => {

  return apiRequest<MediaAccess>(getGrantMediaAccessUrl(teamId),
  {
    ...options,
    method: 'POST'


  }
);}





export const getGrantMediaAccessMutationKey = () => ['grantMediaAccess'] as const;

export const getGrantMediaAccessMutationOptions = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof grantMediaAccess>>, TError,GrantMediaAccessMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof grantMediaAccess>>, TError,GrantMediaAccessMutationVariables, TContext> => {

const mutationKey = getGrantMediaAccessMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof grantMediaAccess>>, GrantMediaAccessMutationVariables> = (props) => {
          const {teamId} = props ?? {};

          return  grantMediaAccess(teamId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type GrantMediaAccessMutationResult = NonNullable<Awaited<ReturnType<typeof grantMediaAccess>>>

    export type GrantMediaAccessMutationError = ErrorType<ErrorEnvelope>
    export type GrantMediaAccessMutationVariables = {teamId: string}

    /**
 * @summary Grant Media Access
 */
export const useGrantMediaAccess = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof grantMediaAccess>>, TError,GrantMediaAccessMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof grantMediaAccess>>,
        TError,
        GrantMediaAccessMutationVariables,
        TContext
      > => {
      return useMutation(getGrantMediaAccessMutationOptions(options), queryClient);
    }
    export const getGetTeamStorageUrl = (teamId: string,) => {




  return `/api/v1/teams/${teamId}/storage`
}

/**
 * The team's storage (spec assets/storage-usage): the bytes its files hold, its library's,
 * its voices' samples and its actors' portraits, and its limit; the header's usage pill reads
 * it. Any member, as live's `GET /team/:id/storage/summary`.
 * @summary Get Team Storage
 */
export const getTeamStorage = async (teamId: string, options?: Parameters<typeof apiRequest>[1]): Promise<TeamStorage> => {

  return apiRequest<TeamStorage>(getGetTeamStorageUrl(teamId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetTeamStorageQueryKey = (teamId: string,) => {
    return [
    `/api/v1/teams/${teamId}/storage`
    ] as const;
    }


export const getGetTeamStorageQueryOptions = <TData = Awaited<ReturnType<typeof getTeamStorage>>, TError = ErrorType<ErrorEnvelope>>(teamId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTeamStorage>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetTeamStorageQueryKey(teamId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getTeamStorage>>> = ({ signal }) => getTeamStorage(teamId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: teamId !== null && teamId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getTeamStorage>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetTeamStorageQueryResult = NonNullable<Awaited<ReturnType<typeof getTeamStorage>>>
export type GetTeamStorageQueryError = ErrorType<ErrorEnvelope>


export function useGetTeamStorage<TData = Awaited<ReturnType<typeof getTeamStorage>>, TError = ErrorType<ErrorEnvelope>>(
 teamId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTeamStorage>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTeamStorage>>,
          TError,
          Awaited<ReturnType<typeof getTeamStorage>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTeamStorage<TData = Awaited<ReturnType<typeof getTeamStorage>>, TError = ErrorType<ErrorEnvelope>>(
 teamId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTeamStorage>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTeamStorage>>,
          TError,
          Awaited<ReturnType<typeof getTeamStorage>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTeamStorage<TData = Awaited<ReturnType<typeof getTeamStorage>>, TError = ErrorType<ErrorEnvelope>>(
 teamId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTeamStorage>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Team Storage
 */

export function useGetTeamStorage<TData = Awaited<ReturnType<typeof getTeamStorage>>, TError = ErrorType<ErrorEnvelope>>(
 teamId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTeamStorage>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetTeamStorageQueryOptions(teamId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






